<template>
  <div>
    <v-card elevation="0">
      <canvas id="pie-chart" ref="pieChart"></canvas>
    </v-card>
  </div>
</template>

<script>
import Chart from "chart.js";
import Vue from "vue";

const eventBus = new Vue();

export default {
  props: {
    cotizaciones: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      chartData: {
        type: "pie",
        data: {
          labels: [],
          datasets: [
            {
              data: [],
              backgroundColor: [
                "#385083",
                "#20407b",
                "#a74e18",
                "#f37926",
                "#a1a1a1",
                "#f9c302",
                "#589cdb",
                "#67a93b",
              ],
              hoverOffset: 4,
            },
          ],
        },
        options: {
          responsive: true,
          aspectRatio: 2,
          legend: {
            position: "right",
          },
          interaction: {
            mode: "index",
            axis: "y",
          },
        },
        plugins: [
          {
            id: "myEventCatcher",
            beforeEvent(chart, args) {
              if (args.type == "click")
                eventBus.$emit(
                  "clicked",
                  chart.getElementAtEvent(args)[0]._model.label
                );
            },
          },
        ],
      },
    };
  },

  watch: {
    cotizaciones() {
      this.loadChart();
    },
  },

  mounted() {
    this.loadChart();
  },

  methods: {
    loadChart() {
      if (!this.cotizaciones) return;
      this.setChartData();
      const canva = this.$refs.pieChart;

      this.$nextTick(() => {
        new Chart(canva, this.chartData);
        eventBus.$on("clicked", (selectedItem) => {
          this.$emit("searchUpdated", {
            status: this.getPayload(selectedItem),
          });
        });
        eventBus.$on("chartRezize", () => {
          this.loadChart();
        });
      });
    },

    setChartColors() {
      this.chartData.data.labels.forEach(() =>
        this.chartData.data.datasets[0].backgroundColor.push(
          this.$randomColor()
        )
      );
    },

    setChartData() {
      this.chartData.data.labels = [];
      this.chartData.data.datasets[0].data = [];

      // Se configuran la renderización en vistas pequeñas
      if (this.$vuetify.breakpoint.xsOnly) {
        this.chartData.options = {
          responsive: true,
          aspectRatio: 0.7,
          legend: {
            position: "bottom",
          },
        };
      }

      Object.keys(this.cotizaciones).forEach((e) => {
        this.chartData.data.labels.push(e);
        this.chartData.data.datasets[0].data.push(this.cotizaciones[e]);
      });
    },

    getPayload(selectedItem) {
      const dictionary = {
        Nueva: 0,
        Asignada: 1,
        "En tramite": 2,
        "Pendiente de Aprobacion": 3,
        "Pendiente de Informacion": 4,
        Recotizar: 5,
        Cerrada: 6,
        Cancelada: 7,
      };

      return dictionary[selectedItem];
    },
  },
};
</script>
